import React from 'react'
import Text from 'react-text'
import Select from 'react-select'
import Icon from '../../icon'
import {Consumer} from '../../../context'
import './filters.styl'

function SelectFilter(props) {
  const className = `select-${props.name}`
  return (<Consumer>{ context => {
    const id = context.query[props.valueProperty]
    const value = context[props.name].find(prop => prop.id == id)
    const placeholder = context.translate(`${props.name}_filters_no_options_message`)
    return (
      <div className={className}>
        <div className="dropdown">
          <Select
            className={className}
            classNamePrefix="select"
            formatOptionLabel = {({name}) => name}
            isSearchable = {false}
            isClearable = {true}
            escapeClearsValue = {true}
            getOptionValue = {({id}) => id}
            placeholder = {placeholder}
            value = {value}
            onChange = {option => {
              const {id} = option || {}
              const query = {[props.valueProperty]: id, page: undefined}
              context.navigate({}, context.match.path, {preserveQuery: true, query})
            }}
            options = {context[props.name]}
          />
        </div>
      </div>
    )
  }}</Consumer>)
}

export default function Filters (props) {
  return (<Consumer>{ context => {
    const [pageProperties] = context.myLessons
    const {recordCount} = pageProperties || {}
    return (
      <div className="filters-wrapper">
        <div className="filters">
          <div className="label-wrapper">
            <div className="label">
              <div className="icon">
                <Icon name="lesson-count" />
              </div>
              <div className="count">
                { recordCount > 0 && (<React.Fragment>
                  <Text id="uploaded_lessons_label" />: {recordCount}
                </React.Fragment>) }
              </div>
            </div>
          </div>
          <div style={{flexGrow: 1}} />
          <SelectFilter name="grades" valueProperty="grade" />
        </div>
      </div>
    )
  }}</Consumer>)
}
